import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './common/httpRequest/api.js'
import axios from 'axios'
import Print from './components/vue-print-nb/print.js'
import {
	Pagination,
	Button,
	Link,
	DatePicker,
	Icon,
	Carousel,
	CarouselItem,
	Message,
	MessageBox ,
	Row,
	Col,
	Avatar,
	PageHeader,
	Breadcrumb,
	BreadcrumbItem,
	Checkbox,
	CascaderPanel,
	Upload,
	Dialog,
	Cascader,
	Progress,
	Table,
	TableColumn,
	Switch,
	Select,
	Option,
	Input,
	Tabs,
	TabPane,
	InfiniteScroll,
	CheckboxGroup,
	Tree,
	Form,
	CheckboxButton,
	Radio,
	Image,
	Loading,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	ColorPicker
} from 'element-ui'
Vue.use(Print) // 打印
Vue.use(Pagination)
Vue.use(Button)
Vue.use(Link)
Vue.use(DatePicker)
Vue.use(Icon)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Avatar)
Vue.use(Row)
Vue.use(Col)
Vue.use(PageHeader)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Checkbox)
Vue.use(CascaderPanel)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Cascader)
Vue.use(Progress)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(InfiniteScroll)
Vue.use(CheckboxGroup)
Vue.use(Tree)
Vue.use(Form)
Vue.use(CheckboxButton)
Vue.use(Radio)
Vue.use(Image)
Vue.use(Loading)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(ColorPicker)
Vue.prototype.$getDate = function timestampToTime(timestamp) {
  var date = new Date(timestamp * 1000)
  var Y = date.getFullYear() + '年'
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
  const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '日'
  // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
  // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
  return Y + M + D
}
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$api = api
Vue.prototype.$store = store
Vue.prototype.$axios = axios
Vue.prototype.$apiurl = 'https://www.spmall.com/';
// Vue.prototype.$apiurl = 'http://192.168.0.113/';
Vue.config.productionTip = false
Vue.directive('infinite-scroll', InfiniteScroll)
// router.beforeEach((to, from, next, store) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }else{
// 		// console.log(from)
// 	}
//   next()
// })
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
